<template>
  <v-card flat>
    <v-row>
      <v-col xl="9" lg="8" sm="8" xs="6">
        <v-pagination
          v-model="currentPage"
          :length="lastPage"
          :total-visible="6"
          circle
        ></v-pagination>
      </v-col>
      <v-col xl="1" lg="2" sm="2" class="pr-0"><v-row align="end" class="pr-0"><v-col class="pr-0">{{ $vuetify.lang.locales[lang].dataTable.itemsPerPageText }}</v-col></v-row></v-col>
      <v-col xl="1" lg="1" sm="1" xs="2">
        <v-select v-model="itemsPerPage" :items="items" dense></v-select>
      </v-col>
      <v-col>
        <v-spacer></v-spacer>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  name: 'Paginate',

  props: {
    store: {
      type: String,
      required: true
    },
    collection: {
      type: String,
      required: true
    }
  },

  data: () => ({
    itemsPerPage: '10',
    items: ['10', '15', '25', '50']
  }),

  computed: {
    lang() {
      return this.$store.getters['localization/lang'];
    },
    currentPage: {
      get() {
        return this.$store.state[this.store][this.collection].meta.current_page;
      },
      set(value) {
        this.$store.commit(this.store + '/setCurrentPage', value);
      }
    },
    lastPage: {
      get() {
        return this.$store.state[this.store][this.collection].meta.last_page;
      }
    }
  },

  watch: {
    currentPage(newVal) {
      this.paginatePage(newVal);
    },

    itemsPerPage() {
      this.paginatePage();
    }
  },

  methods: {
    paginatePage() {
      this.$store
        .dispatch(this.store + '/getList', {
          pageNumber: this.currentPage,
          itemsPerPage: this.itemsPerPage
        })
        .then(({ data }) => {
          this.$store.commit('notification/retrievedNotifications', data);
        })
        .catch(error => {
          console.log('error');
          this.error = error.response;
        });
    }
  }
};
</script>
